import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { BASE_API_URL } from "store/Me";
import { BaseLivlyApiResponse } from "./useGetSystemTypes";

export interface CsvLockUploadPayload {
  file: File;
  propertyExternalIdOverride?: string;
  propertyNameOverride?: string;
}

export default function usePostCsvLock(siteId: string) {
  const postCsv = async (payload: CsvLockUploadPayload) => {
    const { file, propertyExternalIdOverride, propertyNameOverride } = payload;
    const formData = new FormData();
    formData.append("file", file, file.name);
    if (propertyExternalIdOverride) {
      formData.append(
        "propertyExternalIdOverride",
        propertyExternalIdOverride.trim(),
      );
    }
    if (propertyNameOverride) {
      formData.append("propertyNameOverride", propertyNameOverride.trim());
    }

    const result = await axios.post<BaseLivlyApiResponse<any>>(
      `${BASE_API_URL}/api/sites/${siteId}/locks/batch`,
      formData,
    );

    return result.data;
  };

  return useMutation({
    mutationFn: (payload: CsvLockUploadPayload) => postCsv(payload),
  });
}
